import { createApp, pinia } from './vue';

import ridingschoolApp from './vue/apps/ridingschool';

const ridingschoolAppMountingContainer = document.getElementById('js-ridingschool-app');

if (ridingschoolAppMountingContainer) {
    createApp(ridingschoolApp).use(pinia).mount(ridingschoolAppMountingContainer);
}
